import React from 'react'

import { Button } from 'reactstrap';

const OrganizationHeaderActions = ({ showSetDefault, setDefault }) => {

  return (
    <>
      {showSetDefault && (
        <Button onClick={setDefault} color={'primary'} size="sm">
          Set As Default
        </Button>
      )}
    </>
  )
}

export default OrganizationHeaderActions